<img id="logo" src="assets/img/ogi-logo.png" alt="" />
<div id="page">
  <div id="container">
    <h4>Password reset</h4>
    <p>Your password was successfully changed.</p>
    <div id="reset-successful">
      <app-button
        buttonStyle="standard"
        label="Return to login"
        buttonId="login"
        [routerLink]="'/login'"
      >
      </app-button>
    </div>
  </div>
</div>
